import { useSelector } from "react-redux";
import _ from 'lodash'

const useRolePermissionServices = ()=>{  
   
   let allRoles = [];

   allRoles = useSelector((state)=>{
       return state.auth.roles
   })

   const CensusRoles = {
       canAssignOrReserveBeds:_.includes(allRoles, "bedmanagement.reservebed")

   }
 
    const AttendanceRoles = {
        canMarkAttendance: _.includes(allRoles, "bedmanagement.recordattendance")
    }

    const SetupRoles = {
        canModify:_.includes(allRoles, "bedmanagement.modifybed"),
        canViewSetup:_.includes(allRoles, "bedmanagement.accesssetup"),
        canAssignStaff:_.includes(allRoles, "bedmanagement.addandremovestaff")
    }

    const WaitlistRoles = {
        canModifyWaitlist:_.includes(allRoles, "bedmanagement.modifywaitlist"),
        canModifyWaitlistClient:_.includes(allRoles, "bedmanagement.modifywaitlistclient")
    }
    
    return {data:{CensusRoles, AttendanceRoles, SetupRoles, WaitlistRoles}}
}

export default useRolePermissionServices